module.exports = __webpack_public_path__ + "static/media/Puracy.81d8d622.png";